<div #chart class="w-full h-full min-h-[400px]"></div>